import React from "react";
import Countdown, { zeroPad } from "react-countdown";

import { Flex, Text } from "@chakra-ui/react";

export default function IWCountDown({ date }) {
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <>{`--:--:--`}</>;
    } else {
      return (
        <Flex>
          <Text textAlign="left" minW="168px">
            {`${days ? `${zeroPad(days)}d` : ""} ${zeroPad(hours)}h ${zeroPad(
              minutes
            )}m ${zeroPad(seconds)}s`}
          </Text>
        </Flex>
      );
    }
  };
  return (
    <span>
      <Countdown key={date?.toString()} date={date} renderer={renderer} />
    </span>
  );
}
